import React, { Component } from 'react';
import Avatar from 'react-avatar';
import styled from 'styled-components';
import {Button, Dialog} from '@betareader/design-system';

import { userColorUtil } from '../../utils';
import PublicUserProfile from '../../containers/user/publicUserProfile';

const AvatarFrame = styled.div`
  display: inline-block;
  border: 2px solid var(--br-surface);
  width: ${props => props.diameter ? props.diameter : 20}px;
  height: ${props => props.diameter ? props.diameter : 20}px;
  -webkit-border-radius: 100%; /* Saf3+, Chrome */
  border-radius: 100%; /* Opera 10.5, IE 9 */
  /*-moz-border-radius: 100%;  Disabled for FF1+ */
`;

const AvatarContent = styled(Avatar)`
  width: ${props => props.diameter ? props.diameter : 20}px;
  height: ${props => props.diameter ? props.diameter : 20}px;
  -webkit-border-radius: 100%; /* Saf3+, Chrome */
  border-radius: 100%; /* Opera 10.5, IE 9 */
  /*-moz-border-radius: 100%;  Disabled for FF1+ */
`;

class AvatarComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showUserProfile: false
    };
  }

  getInitials = (name = '') => {
    let initials = (name || '').match(/\b\w/g) || [];
    initials = ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
    return initials;
  }

  showUser = () => {
    this.setState({
      showUserProfile: true
    });
  }

  /**
   * A caller's own onClick wins. The reader list and the survey answer list
   * both pass one and expect it to run -- opening the profile modal is only
   * the fallback for callers that just hand us a userId (chat, comments).
   */
  getClickHandler = () => {
    const { onClick, userId } = this.props;
    return onClick || (userId ? this.showUser : undefined);
  }

  render() {
    const {
      name, src, diameter = 20, userId, nameOnly, style = {}
    } = this.props;
    const { showUserProfile } = this.state;
    const handleClick = this.getClickHandler();
    return (
      <React.Fragment>
        {nameOnly && (handleClick
          ? <button type="button" onClick={handleClick}
            style={{border: 0, padding: 0, background: 'transparent', color: 'inherit',
              font: 'inherit', cursor: 'pointer', ...style}}>{name}</button>
          : <div style={style}>{name}</div>)}
        {
          !nameOnly && (
            <div
              role={handleClick ? 'button' : 'img'}
              tabIndex={handleClick ? 0 : undefined}
              aria-label={name || (handleClick ? 'Open user profile' : 'User avatar')}
              onClick={handleClick}
              onKeyDown={handleClick ? event => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleClick(event);
                }
              } : undefined}
              style={{ width: diameter, height: diameter,
                cursor: handleClick ? 'pointer' : undefined,
                ...style }}>
              <AvatarFrame diameter={diameter}>
                <AvatarContent
                  diameter={diameter}
                  textSizeRatio={this.getInitials(name).length <= 1 ? 3 : 2}
                  name={(name || '')}
                  src={src}
                  initials={this.getInitials(name)}
                  round
                  size='100%'
                  color={`${userColorUtil.getUserColor(name || '')}`}
                  {...this.props}
                  onClick={undefined}
                  style={{
                    fontWeight: 'bold',
                    margin: 0,
                    display: 'block'
                  }}
                />
              </AvatarFrame>
            </div>
          )
        }
        <Dialog
          open={Boolean(userId && showUserProfile)}
          title={name || 'User profile'}
          onClose={() => this.setState({showUserProfile: false})}
          actions={<Button variant="secondary"
            onClick={() => this.setState({showUserProfile: false})}>Close</Button>}
        >
          <PublicUserProfile userId={userId} />
        </Dialog>
      </React.Fragment>
    );
  }
}

export default AvatarComponent;
